
import SetmoreBooking from "@/components/SetmoreBooking";
import phlebotomyDraw from "@/assets/phlebotomy-draw.jpg";

const Booking = () => {
  return (
    <div className="min-h-screen bg-nearlab-gray">
      <div className="relative h-64 md:h-80 overflow-hidden">
        <img 
          src={phlebotomyDraw} 
          alt="Professional certified phlebotomist providing mobile blood draw services" 
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-nearlab-gray"></div>
      </div>
      <SetmoreBooking />
    </div>
  );
};

export default Booking;
